<template>
  <div class="incenters TableBox">
    <!-- style="border: 1px solid red;" -->
    <div>
      <!-- <Commonbtn title="导出"></Commonbtn> -->
      <div class="topstate" v-for="(item , index) of state" :key="index+'title'" :class="[{ 'ativte' : onchage == index}]" @click="clicktab(index)">
        {{ item.title }}
      </div>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth" v-if="tableflag" style="overflow-x: scroll;">
      <Commontable :rowhe="false" colnum=7 :loadingTable="loadingTable"  :tableData="tableDataDetail" :headerData="headerData" height="100%"></Commontable>
    </div>
    <div class="TableWidth" v-if="tableflags">
      <Commontable colnum=7 :tableData="tableDataUnique" :loadingTable="loadingTable"  :headerData="headerData1" height="100%"></Commontable>
    </div>
  </div>
</template>

<script>
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import {
  wmsOtherOutDetail,
  wmsOtherOutDetailUnique

} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,

  },
  props: ['dpmid', 'tableDataUnique', 'tableDataDetail'],
  data: function () {
    return {
      loadingTable: false,
      state: [
        {
          title: '明细'
        },
        {
          title: '唯一码'
        }
      ],
      headerData1: [{
        prop: 'id',
        label: '序号',
        columnwidth: 120
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
        columnwidth: 120
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 260
      },
      {
        prop: 'InvUniqueCode',
        label: '唯一码',
        columnwidth: 450
      },
      {
        prop: 'Quantity',
        label: '数量',
        columnwidth: 450
      },
      ],
      tableData1: [],
      tableData: [],
      headerData: [
        {
          prop: 'id',
          label: '序号',
          columnwidth: 60
        },
        {
          prop: 'InvAddCode',
          label: '商品代码',
          columnwidth: 220
        },
        {
          prop: 'InvName',
          label: '存货名称'
        },
        {
          prop: 'Batch',
          label: '批号',
        },
        {
          prop: 'ValiDate',
          label: '有效期至',
        },
        {
          prop: 'Quantity',
          label: '数量',
        },
        {
          prop: 'VouDCode',
          label: '来源单据表体单号',
        }
      ],
      onchage: 0,
      tableflag: true,
      tableflags: false,
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 明细
    async wmsOtherOutDetail() {
      let {
        data,
        code
      } = await wmsOtherOutDetail({
        dpmid: this.dpmid
      })
      if (code == 0) {
        this.tableDataDetail = data
      }
    },
    // 唯一码
    async wmsOtherOutDetailUnique() {
      let {
        data,
        code
      } = await wmsOtherOutDetailUnique({
        dpmid: this.dpmid
      })
      if (code == 0) {
        this.tableDataDetail = data
      }
    },
    clicktab(index) {
      if (index == 0) {
        this.tableflag = true
        this.tableflags = false
        this.wmsOtherOutDetail()
      }
      if (index == 1) {
        this.tableflag = false
        this.tableflags = true
        this.wmsOtherOutDetailUnique()
      }
      if (this.onchage != index) {
        this.onchage = index
      }
      this.$emit('clicktab', index)
    }
  }
}
</script>

<style lang="less" scoped>
.ativte {
  border: 1px solid red;
  color: #e71d43;
  background-color: #fce8ec;
  transition: 0.2s linear;
}

.incenters {
  height: 100%;
  font-family: "微软雅黑";
  background-color: #fff;
  width: 980px;
  margin-top: 10px;
  padding-bottom: 10px;
  padding-top: 2px;

  div {
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 5px;
    margin-bottom: 5px;
    // width: 100%;
  }
}

.topstate {
  width: 100px;
  height: 32px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  user-select: none;
}
</style>
